import { render, staticRenderFns } from "./fbrw.vue?vue&type=template&id=ba43c306&scoped=true&"
import script from "./fbrw.vue?vue&type=script&lang=js&"
export * from "./fbrw.vue?vue&type=script&lang=js&"
import style0 from "./fbrw.vue?vue&type=style&index=0&id=ba43c306&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba43c306",
  null
  
)

export default component.exports